// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import AC from './AC';
import AD from './AD';
import AE from './AE';
import AF from './AF';
import AG from './AG';
import AI from './AI';
import AL from './AL';
import AM from './AM';
import AO from './AO';
import AR from './AR';
import AS from './AS';
import AT from './AT';
import AU from './AU';
import AW from './AW';
import AX from './AX';
import AZ from './AZ';
import BA from './BA';
import BB from './BB';
import BD from './BD';
import BE from './BE';
import BF from './BF';
import BG from './BG';
import BH from './BH';
import BI from './BI';
import BJ from './BJ';
import BM from './BM';
import BN from './BN';
import BO from './BO';
import BQ from './BQ';
import BR from './BR';
import BS from './BS';
import BT from './BT';
import BW from './BW';
import BY from './BY';
import BZ from './BZ';
import CA from './CA';
import CD from './CD';
import CF from './CF';
import CG from './CG';
import CH from './CH';
import CI from './CI';
import CK from './CK';
import CL from './CL';
import CM from './CM';
import CN from './CN';
import CO from './CO';
import CR from './CR';
import CU from './CU';
import CV from './CV';
import CW from './CW';
import CY from './CY';
import CZ from './CZ';
import DE from './DE';
import DJ from './DJ';
import DK from './DK';
import DM from './DM';
import DO from './DO';
import DZ from './DZ';
import EC from './EC';
import EE from './EE';
import EG from './EG';
import EH from './EH';
import ER from './ER';
import ES from './ES';
import ET from './ET';
import FI from './FI';
import FJ from './FJ';
import FK from './FK';
import FM from './FM';
import FO from './FO';
import FR from './FR';
import GA from './GA';
import GB from './GB';
import GD from './GD';
import GE from './GE';
import GF from './GF';
import GG from './GG';
import GH from './GH';
import GI from './GI';
import GL from './GL';
import GM from './GM';
import GN from './GN';
import GP from './GP';
import GQ from './GQ';
import GR from './GR';
import GT from './GT';
import GU from './GU';
import GW from './GW';
import GY from './GY';
import HK from './HK';
import HN from './HN';
import HR from './HR';
import HT from './HT';
import HU from './HU';
import ID from './ID';
import IE from './IE';
import IL from './IL';
import IM from './IM';
import IN from './IN';
import IO from './IO';
import IQ from './IQ';
import IR from './IR';
import IS from './IS';
import IT from './IT';
import JE from './JE';
import JM from './JM';
import JO from './JO';
import JP from './JP';
import KE from './KE';
import KG from './KG';
import KH from './KH';
import KI from './KI';
import KM from './KM';
import KN from './KN';
import KP from './KP';
import KR from './KR';
import KW from './KW';
import KY from './KY';
import KZ from './KZ';
import LA from './LA';
import LB from './LB';
import LC from './LC';
import LI from './LI';
import LK from './LK';
import LR from './LR';
import LS from './LS';
import LT from './LT';
import LU from './LU';
import LV from './LV';
import LY from './LY';
import MA from './MA';
import MC from './MC';
import MD from './MD';
import ME from './ME';
import MG from './MG';
import MH from './MH';
import MK from './MK';
import ML from './ML';
import MM from './MM';
import MN from './MN';
import MO from './MO';
import MP from './MP';
import MQ from './MQ';
import MR from './MR';
import MS from './MS';
import MT from './MT';
import MU from './MU';
import MV from './MV';
import MW from './MW';
import MX from './MX';
import MY from './MY';
import MZ from './MZ';
import NA from './NA';
import NC from './NC';
import NE from './NE';
import NF from './NF';
import NG from './NG';
import NI from './NI';
import NL from './NL';
import NO from './NO';
import NP from './NP';
import NR from './NR';
import NU from './NU';
import NZ from './NZ';
import OM from './OM';
import PA from './PA';
import PE from './PE';
import PF from './PF';
import PG from './PG';
import PH from './PH';
import PK from './PK';
import PL from './PL';
import PM from './PM';
import PR from './PR';
import PS from './PS';
import PT from './PT';
import PW from './PW';
import PY from './PY';
import QA from './QA';
import RE from './RE';
import RO from './RO';
import RS from './RS';
import RU from './RU';
import RW from './RW';
import SA from './SA';
import SB from './SB';
import SC from './SC';
import SD from './SD';
import SE from './SE';
import SG from './SG';
import SH from './SH';
import SI from './SI';
import SJ from './SJ';
import SK from './SK';
import SL from './SL';
import SM from './SM';
import SN from './SN';
import SO from './SO';
import SR from './SR';
import SS from './SS';
import ST from './ST';
import SV from './SV';
import SX from './SX';
import SY from './SY';
import SZ from './SZ';
import TC from './TC';
import TD from './TD';
import TG from './TG';
import TH from './TH';
import TJ from './TJ';
import TK from './TK';
import TL from './TL';
import TM from './TM';
import TN from './TN';
import TO from './TO';
import TR from './TR';
import TT from './TT';
import TV from './TV';
import TW from './TW';
import TZ from './TZ';
import UA from './UA';
import UG from './UG';
import US from './US';
import UY from './UY';
import UZ from './UZ';
import VA from './VA';
import VC from './VC';
import VE from './VE';
import VG from './VG';
import VI from './VI';
import VN from './VN';
import VU from './VU';
import WF from './WF';
import WS from './WS';
import XK from './XK';
import YE from './YE';
import YT from './YT';
import ZA from './ZA';
import ZM from './ZM';
import ZW from './ZW';

const phoneNumberValidationPatterns = {
  AC,
  AD,
  AE,
  AF,
  AG,
  AI,
  AL,
  AM,
  AO,
  AR,
  AS,
  AT,
  AU,
  AW,
  AX,
  AZ,
  BA,
  BB,
  BD,
  BE,
  BF,
  BG,
  BH,
  BI,
  BJ,
  BM,
  BN,
  BO,
  BQ,
  BR,
  BS,
  BT,
  BW,
  BY,
  BZ,
  CA,
  CD,
  CF,
  CG,
  CH,
  CI,
  CK,
  CL,
  CM,
  CN,
  CO,
  CR,
  CU,
  CV,
  CW,
  CY,
  CZ,
  DE,
  DJ,
  DK,
  DM,
  DO,
  DZ,
  EC,
  EE,
  EG,
  EH,
  ER,
  ES,
  ET,
  FI,
  FJ,
  FK,
  FM,
  FO,
  FR,
  GA,
  GB,
  GD,
  GE,
  GF,
  GG,
  GH,
  GI,
  GL,
  GM,
  GN,
  GP,
  GQ,
  GR,
  GT,
  GU,
  GW,
  GY,
  HK,
  HN,
  HR,
  HT,
  HU,
  ID,
  IE,
  IL,
  IM,
  IN,
  IO,
  IQ,
  IR,
  IS,
  IT,
  JE,
  JM,
  JO,
  JP,
  KE,
  KG,
  KH,
  KI,
  KM,
  KN,
  KP,
  KR,
  KW,
  KY,
  KZ,
  LA,
  LB,
  LC,
  LI,
  LK,
  LR,
  LS,
  LT,
  LU,
  LV,
  LY,
  MA,
  MC,
  MD,
  ME,
  MG,
  MH,
  MK,
  ML,
  MM,
  MN,
  MO,
  MP,
  MQ,
  MR,
  MS,
  MT,
  MU,
  MV,
  MW,
  MX,
  MY,
  MZ,
  NA,
  NC,
  NE,
  NF,
  NG,
  NI,
  NL,
  NO,
  NP,
  NR,
  NU,
  NZ,
  OM,
  PA,
  PE,
  PF,
  PG,
  PH,
  PK,
  PL,
  PM,
  PR,
  PS,
  PT,
  PW,
  PY,
  QA,
  RE,
  RO,
  RS,
  RU,
  RW,
  SA,
  SB,
  SC,
  SD,
  SE,
  SG,
  SH,
  SI,
  SJ,
  SK,
  SL,
  SM,
  SN,
  SO,
  SR,
  SS,
  ST,
  SV,
  SX,
  SY,
  SZ,
  TC,
  TD,
  TG,
  TH,
  TJ,
  TK,
  TL,
  TM,
  TN,
  TO,
  TR,
  TT,
  TV,
  TW,
  TZ,
  UA,
  UG,
  US,
  UY,
  UZ,
  VA,
  VC,
  VE,
  VG,
  VI,
  VN,
  VU,
  WF,
  WS,
  XK,
  YE,
  YT,
  ZA,
  ZM,
  ZW,
};

export default phoneNumberValidationPatterns;
